import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { EMPTY_VALUE } from '../../types';
import { styled } from '../../utils';
import { SummaryTable } from './SummaryTable';
export function SummarySection({ rows: initialRows, editable = true, noValues = false, alignItems, initiallyExpanded, ...otherProps }) {
    // show values in blue
    // FIXME: next-dev.js?36dd:32 Warning: Each child in a list should have a unique "key" prop.
    // FIXME: Use UnknownType instead of EMPTY_VALUE
    const rows = useMemo(() => initialRows.map(({ label, value }) => ({
        label,
        value: noValues ? null : value ? (_jsx(ValueStyled, { children: value })) : (EMPTY_VALUE),
    })), [initialRows, noValues]);
    return (_jsx(SummaryTable, { rows: rows, noRowPadding: true, striped: false, filled: false, editable: editable, alignItems: alignItems || 'flex-start', expandable: "small-screens", initiallyExpanded: initiallyExpanded !== undefined ? initiallyExpanded : true, ...otherProps }));
}
const ValueStyled = styled('span')(({ theme }) => ({
    color: theme.palette.primary.dark,
}));
